export default __webpack_public_path__ + "static/media/portfolio.e20ecf5b.png";